import { useFeatureIsOn } from '@growthbook/growthbook-react';
import GROWTHBOOK_FEATURE_FLAGS from '../shared/utils/growthbook.util';

const useGrowthbookExperiment = () => {
	const satIsDown = useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.SAT_IS_DOWN);

	return {
		showChatAI: false,
		satIsDown,
	};
};

export default useGrowthbookExperiment;
